enum EcommerceCartDataSourceEnum {
	default = 'default',
	disabled = 'disabled',
	iows = 'IOWS',
	cartApi = 'CartApi',
	chinaCartApi = 'ChinaCartApi',
	nifApi = 'NifApi',
	mvecom = 'MvEcom',
	mvecomV2 = 'MvEcomV2',
	iksa = 'IKSA'
}

export default EcommerceCartDataSourceEnum;
